/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Unseat/view.blocks to change it.
import * as fromData from 'Simple/Data'
import MissingRequiredTreatmentFieldsDialog from './MissingRequiredTreatmentFieldsDialog/index'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function Unseat({
  children,
  viewPath = "/App/Account/PatientOverlay/Content/Content/Appointments/TabContent/Content/AppointmentsList/Content/Appointment/BottomAction/Content/Unseat",
  onSubmit
  
}) {
let unseatSubmitData = fromData.useDataSubmit({ viewPath,
context: 'unseat',
})
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 size="small"
 type="secondary"
 data="unseat"
 onClick={unseatSubmitData}
 text="Unseat"
/>
<MissingRequiredTreatmentFieldsDialog
  viewPath={`${viewPath}/MissingRequiredTreatmentFieldsDialog`}
/>
{children}
</React.Fragment>)
}